import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
export interface CompliancePolicy {
  allowedModels: string[];
  restrictedTools: string[];
  dataResidency: 'EU' | 'US' | 'APAC';
  piiMaskingEnabled: boolean;
}
interface ComplianceState {
  policy: CompliancePolicy;
  riskScore: number; // 0 to 100
  updatePolicy: (updates: Partial<CompliancePolicy>) => void;
  analyzeRisk: (content: string) => number;
}
const HIGH_RISK_KEYWORDS = ['biometric', 'social scoring', 'critical infrastructure', 'judicial', 'police', 'recruitment'];
export const useComplianceStore = create<ComplianceState>()(
  persist(
    (set) => ({
      policy: {
        allowedModels: ['GPT-4o', 'Claude-3.5-Sonnet'],
        restrictedTools: ['DarkWebSearch'],
        dataResidency: 'EU',
        piiMaskingEnabled: true
      },
      riskScore: 12,
      updatePolicy: (updates) => set((state) => ({ policy: { ...state.policy, ...updates } })),
      analyzeRisk: (content) => {
        const count = HIGH_RISK_KEYWORDS.filter(k => content.toLowerCase().includes(k)).length;
        const score = Math.min(100, count * 20 + 5);
        set({ riskScore: score });
        return score;
      }
    }),
    {
      name: 'cloudface-compliance-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
export const useCompliancePolicy = () => useComplianceStore((s) => s.policy);
export const useRiskScore = () => useComplianceStore((s) => s.riskScore);
export const useUpdateCompliancePolicy = () => useComplianceStore((s) => s.updatePolicy);
export const useAnalyzeComplianceRisk = () => useComplianceStore((s) => s.analyzeRisk);